/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect } from 'react';
import { S3_LESSONS } from 'Constants/General';
import { CircularProgress } from '@mui/material';
import { AudioFile, VideocamOutlined } from '@mui/icons-material';
import { getSignedUrl } from 'Services/AWS/s3';
import { LessonContainer, LessonImage, isActiveStyle, noImageIcon, lessonTitle, thumbnailImage } from './style';

function Lesson({ lesson, isActive, callback, moduleId }) {
  return (
    <LessonContainer key={lesson.id} style={isActive ? isActiveStyle : null} onClick={() => callback(lesson)}>
      {lesson?.LessonType?.name === 'video' ? (
        <VideocamOutlined fontSize="large" style={noImageIcon} />
      ) : (
        <AudioFile fontSize="large" style={noImageIcon} />
      )}
      <div style={lessonTitle}>{lesson.name}</div>
    </LessonContainer>
  );
}

export default Lesson;
